import type { ReactNode } from 'react';
import { Link, useRouterState } from '@tanstack/react-router';
import { BusFront, Database } from 'lucide-react';
import { useCanEnterSurface } from '@/lib/platform/surfaces';
import { SURFACES } from '@/lib/gql/__generated__/surfaces';
export function Chrome({ children }: { children: ReactNode }) {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const canPublish = useCanEnterSurface(SURFACES['schedule-data']);
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border bg-card">
        <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-3 px-4 py-4 sm:px-8">
          <Link
            to="/"
            className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground hover:text-primary focus-visible:outline-2 focus-visible:outline-ring"
          >
            <span className="flex size-9 items-center justify-center rounded-md bg-primary text-primary-foreground">
              <BusFront className="size-5" />
            </span>
            Seattle Bus Times
          </Link>
          <nav aria-label="Main navigation" className="flex items-center gap-2 text-sm font-medium">
            <Link
              to="/"
              data-jr-key="bus-times-nav-link"
              aria-current={pathname === '/' ? 'page' : undefined}
              className="rounded-md px-3 py-2 hover:bg-muted focus-visible:outline-2 focus-visible:outline-ring aria-[current=page]:bg-secondary aria-[current=page]:text-primary"
            >
              Bus times
            </Link>
            {canPublish && (
              <Link
                to="/schedule-data"
                data-jr-key="schedule-data-nav-link"
                aria-current={pathname === '/schedule-data' ? 'page' : undefined}
                className="flex items-center gap-2 rounded-md px-3 py-2 hover:bg-muted focus-visible:outline-2 focus-visible:outline-ring aria-[current=page]:bg-secondary aria-[current=page]:text-primary"
              >
                <Database className="size-4" />
                Schedule data
              </Link>
            )}
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-8 sm:px-8 sm:py-12">{children}</main>
      <footer className="mx-auto max-w-5xl border-t border-border px-4 py-6 text-xs text-muted-foreground sm:px-8">
        Scheduled times only · Seattle local time · Not live arrivals
      </footer>
    </div>
  );
}
